<template>
    <div class="c-boost-marketing">
        <div class="c-boost-marketing__bg">
            <div class="c-boost-marketing__title">
                <h2 v-html="titleAsHtmlGenerator" />
            </div>
            <div class="c-boost-marketing__content">
                <h6 class="mb-3">
                    {{ content.synopsis }}
                </h6>
                <div class="d-f justify-content-center align-items-center">
                    <y-button
                        class="text-box-btn mb-5"
                        color="primary"
                        :tag="isLink(content.custom['button-link']) ? 'a' : 'router-link'"
                        :to="content.custom['button-link']"
                        :href="content.custom['button-link']"
                    >
                        {{ content.custom['button-title'] }}
                    </y-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { isLink } from '@/helpers/helpers';

    export default {
        name : 'BoostYourMarketing',
        props: {
            content: Object,
        },
        computed: {
            /**
             * content html title
             *
             * @returns {string}
             */
            titleAsHtmlGenerator() {
                const str = this.content.title.replace('*$*', `<br><span class="custom-bold-word">${this.content.custom.words}</span>`);
                return `<span>${str}</span>`;
            },
        },
        methods: {
            isLink,
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
